import { AppContainer } from 'react-hot-loader';
import React from 'react';
import 'babel-polyfill';
import ReactDOM from 'react-dom';

import {LicenseManager} from "ag-grid-enterprise";
LicenseManager.setLicenseKey("SHI_International_Corp_-_USA__on_behalf_of_Macys_MultiApp_7Devs6_December_2019__MTU3NTU5MDQwMDAwMA==a47df902c35bf9d739a9696ba989f4e7");

import App from './components/App';
import { getEnvironment } from './services/offpriceServices'
import { initializeSocket } from './utilities/socketioClient'
import get from 'lodash/get';
import { Provider } from "react-redux";
import { createStore } from "redux";
import reducers from "./components/redux/reducer/SearchCriteriaReducer"

window.$cdpEnabled = 'true';

const render = Component =>
  ReactDOM.render(
    <Provider store={createStore(reducers)}>
    <AppContainer>
      <Component />
    </AppContainer>
    </Provider>,
    document.getElementById('root')
  );

// Webpack Hot Module Replacement API
if (module.hot){
  module.hot.accept('./components/App', () => render(App))
}

(() => {
  const userName = sessionStorage.getItem('userName')
  if (userName && userName !== '') {
    initializeSocket(userName)
    render(App)
  } else {
    getEnvironment().then((res) => {
      const userName = get(res, 'data.userName');
      const updateEnabled = get(res, 'data.UPDTORDER_ENABLE');
      sessionStorage.clear();
      sessionStorage.setItem('updateEnabled', updateEnabled);
      if (userName) {
        initializeSocket(userName)
      }
      render(App)
    }, (r) => {
      console.log(r)
      alert('We are having problems trying to connect to the server. Please try again later.')
    })
  }
})()



// WEBPACK FOOTER //
// ./index.js